import { IonPage } from '@ionic/react';
import React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { createStructuredSelector } from "reselect";

import { MatchedLoadContainer } from '../MatchedLoadContainer/index';
import { UpdateComponentContainer } from '../UpdateComponentContainer/index';

import useInjectSaga from "../../../utils/injectSaga";
import useInjectReducer from "../../../utils/injectReducer";

import reducer from "../../../reducers/Home/reducer";
import saga from "../../../saga/Home/saga";
import { getNetworkStatus, getUserMasterData } from '../../../selectors/selector';
import { MyLoadsContainer } from '../MyLoadsContainer';
import { isEntitled } from '../../../utils/common';

const key = "carrier";

const DashoardContainer: React.FC<any> = (props: any) => {
    return (
        <IonPage className="desktop-page">
            <UpdateComponentContainer {...props} />
            {(isEntitled("manage", "carrierProfile")) && (                
                <MyLoadsContainer {...props} isHome />
            )}
            {(isEntitled("home", "recommended") && isEntitled("home", "watched")) &&
                <MatchedLoadContainer clearTopRecommedLoadDetails={()=>{}} tabCallbackSegmentChange={()=>{}} {...props} isHome />
            }
        </IonPage>
    );
}

const mapStateToProps = createStructuredSelector({
    userDetails: getUserMasterData(),
    isNetworkAvailable: getNetworkStatus(),

});

export const mapDispatchToProps = (dispatch: Function) => ({
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });
export default compose(
    withSaga,
    withReducer,
    withConnect
)(withRouter(DashoardContainer));
